import React from "react";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLogoutNull } from "../../actions/login/LoginAction";
import { seCompanyNull } from "../../actions/companyDetails/CompanyDetailsAction";
import {
  setTableSearchInput,
  setTableSortingData,
} from "../../actions/tableListing/tableSortingActionData";
import {
  setPaymentTableFilter,
  setSelectedCustomerData,
} from "../../actions/paymentTableFilter/paymentTableFilterAction";
import {
  setGlobalFiltersIds,
  setGlobalFiltersSapCode,
  setGlobalResetFilters,
} from "../../actions/globalFilter/globalFilterAction";
import { checkIsMobileDevice } from "../../helper/checkIsMobileDevice";

const LogoutCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const status = params.get("status");
    const type = params.get("type");

    if (status === "success" && type) {
      if (checkIsMobileDevice()) {
        dispatch(setLogoutNull(null));
        dispatch(seCompanyNull(null));
        dispatch(setTableSortingData(null));
        dispatch(setTableSearchInput(""));
        dispatch(setPaymentTableFilter(""));
        dispatch(setGlobalFiltersIds(null));
        dispatch(setGlobalFiltersSapCode(null));
        dispatch(setGlobalResetFilters());
        dispatch(setSelectedCustomerData(null));
        localStorage.clear();
        navigate("/");
      } else {
        navigate("/galaxyHome");
      }
    } else {
      navigate("/");
    }
  }, [location, navigate]);

  return <div>Redirecting...</div>;
};

export default LogoutCallback;
